import { createFileRoute } from "@tanstack/react-router";
import { Suspense, useState } from "react";
import { GlobalShell } from "~/components/GlobalShell";
import { useRouter, useSearchParams } from "~/components/navigation";
import { Button } from "~/components/Button";
import { trpc } from "~/utils/trpc.client";
import { PasswordStrengthMeterLazy } from "~/components/PasswordStrengthMeterLazy";

export const Route = createFileRoute("/reset-password-success-set-password")({
  component: ResetPasswordSuccessSetPasswordPage,
});

function ResetPasswordSuccessSetPasswordPage() {
  const params = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [passwordStrength, setPasswordStrength] = useState(0);

  const resetPassword = trpc.auth.resetPassword.useMutation();

  const validatePasswords = () => {
    if (passwordStrength < 3) {
      setPasswordError("Password is too weak");
      return false;
    }

    if (password !== confirmPassword) {
      setPasswordError("Passwords do not match");
      return false;
    }
    setPasswordError("");
    return true;
  };

  const router = useRouter();

  return (
    <GlobalShell>
      <div className="flex items-center justify-center">
        <div className="card bg-base-100 w-96 shadow-xl max-w-[90vw]">
          <div className="card-body">
            <h2 className="card-title">Reset Password</h2>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                if (!validatePasswords()) {
                  return;
                }
                resetPassword.mutate(
                  {
                    password,
                    token: params.get("token") ?? "",
                  },
                  {
                    onSuccess: () => {
                      router.push("/");
                    },
                    onError: (err) => {
                      console.error(err);
                      setPasswordError(err.message);
                    },
                  },
                );
              }}
            >
              <div className="form-control mt-4">
                <label className="label">
                  <span className="label-text">Password</span>
                </label>
                <input
                  type="password"
                  placeholder="••••••••"
                  className="input input-bordered"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  name="password"
                  required
                />
                <Suspense fallback={<div></div>}>
                  <PasswordStrengthMeterLazy
                    password={password}
                    onStrengthChange={setPasswordStrength}
                  />
                </Suspense>
              </div>
              <div className="form-control mt-4">
                <label className="label">
                  <span className="label-text">Confirm Password</span>
                </label>
                <input
                  type="password"
                  placeholder="••••••••"
                  className="input input-bordered"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                  required
                />
              </div>
              {passwordError && (
                <div className="mt-4 text-red-600">
                  <div className="flex items-center">{passwordError}</div>
                </div>
              )}
              <div className="form-control mt-6">
                <Button
                  className="btn btn-primary"
                  type="submit"
                  loading={resetPassword.isPending}
                >
                  Set Password
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </GlobalShell>
  );
}
